module.exports = __webpack_public_path__ + "static/media/placeholder.8fc2c29a.svg";